export const FIXED_EXPECTED_DEVICE_MODEL = 'iPhone 17 Pro Max';

export const settingsPanelStyles = {
  section: {
    border: '1px solid var(--mantine-color-default-border)',
  },
  title: {
    color: 'var(--mantine-color-text)',
  },
} as const;
